module.exports = __webpack_public_path__ + "img/serotonin.028b25ef.png";